import React from 'react'

export const OptionsContext = React.createContext({ contractDisabled: false, leadsource: 179, directFlow: '' })

const OptionsContextProvider = (props: { children: React.ReactNode, contractDisabled: boolean, leadsource: number, directFlow?: string }) => {
  
  const queryParams = new URLSearchParams(window.location.search)
  
  const options = {
    contractDisabled: props.contractDisabled,
    leadsource: props.leadsource || 179,
    directFlow: props.directFlow || queryParams.get('directFlow') || ''
  }
  
  return (
    <OptionsContext.Provider value={options}>
      {props.children}
    </OptionsContext.Provider>
  )
}

export default OptionsContextProvider
